import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap'
import { Link } from "react-router-dom";
import moment from 'moment';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';

class JobCostDetailsCard extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: props.user,
            loadingData: false,
            data: props.data
        };
    }


    render() {
        return (
            <div class={this.props.class} style={this.props.style}>
                <Row style={{paddingLeft:5}}>
                    <Col md={2} >
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{moment(this.state.data.CreatedDate).format('MM/DD/YYYY')}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.OrderNumber}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.DisplayID}</Form.Label>
                        <br/>
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.PONumber}</Form.Label>
                    </Col>
                    <Col md={3} >
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold' }}>{this.state.data.BuildingName}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>PROJECT</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.OrderDescription}</Form.Label>
                    </Col>
                    <Col md={4} style={{ marginTop: 3, marginBottom: 3, display: 'flex', flexDirection: 'column', padding:'0px 0px 0px 5px' }}>
                        <Form.Control as="textarea" value={this.state.data.Notes} disabled style={{ marginBottom: 0, width: '100%' }} hidden={this.state.data.Notes == ''} />
                    </Col>
                    <Col md={3} style={{ marginTop: 3, marginBottom: 3, display:'flex', flexDirection:'column' }}>
                        <Button as={Link} to={{
                            pathname: "/scheduling_request",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }} size="sm" className="stacked-button-top" variant="primary">Scheduling Request</Button>
                        <Button as={Link} to={{
                            pathname: "/order_inquiry",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }}  size="sm" className="stacked-button-bottom" variant="primary">Service Inquiry</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default JobCostDetailsCard;